import { ItemHealthLevel } from '@/common/api/types/dashboard/health';
import { SEVERITY, type Severity } from './severity';

export const HEALTH_LEVEL_SEVERITY: Record<ItemHealthLevel, Severity> = {
  [ItemHealthLevel.HEALTHY]: SEVERITY.SUCCESS,
  [ItemHealthLevel.NEEDS_ATTENTION]: SEVERITY.WARNING,
  [ItemHealthLevel.ACTION_REQUIRED]: SEVERITY.ERROR,
  [ItemHealthLevel.DONE]: SEVERITY.INFORMATIVE,
};

export const ITEM_HEALTH_PROGRESS_INDICATOR_CLASS: Record<ItemHealthLevel, string> = {
  [ItemHealthLevel.HEALTHY]: 'bg-bg-success-subtle',
  [ItemHealthLevel.NEEDS_ATTENTION]: 'bg-bg-warning-subtle',
  [ItemHealthLevel.ACTION_REQUIRED]: 'bg-bg-error-subtle',
  [ItemHealthLevel.DONE]: 'bg-bg-neutral-bold',
};
